import React, { useMemo } from 'react'
import Select from 'react-select'
import { useMasterData } from '../../utils/useMasterData'

function EditFinancePartner({ FinancePartnerData, sendDataToParent }) {
  const { items: interestRateItems, loading: interestRateLoading } = useMasterData('interestRates')

  const interestRateOptions = useMemo(() => {
    return (interestRateItems || []).map((item) => ({
      value: item.ValueName ?? '',
      label: item.DisplayName || item.ValueName || '',
      id: item.MasterValueId
    }))
  }, [interestRateItems])

  function handleChange(e) {
    const { name, value } = e.currentTarget
    sendDataToParent({
      ...FinancePartnerData,
      [name]: value,
    })
  }

  const selectedInterestRate = useMemo(() => {
    if (!FinancePartnerData?.InterestRate) return null
    const valueStr = FinancePartnerData.InterestRate.toString()
    return interestRateOptions.find((opt) => opt.value === valueStr) || null
  }, [FinancePartnerData?.InterestRate, interestRateOptions])

  const handleInterestRateChange = (option) => {
    const value = option ? option.value : ''
    sendDataToParent({
      ...FinancePartnerData,
      InterestRate: value,
    })
  }

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">Finance Partner Name <span style={{ color: 'red' }}>*</span></label>
          <input
            type="hidden"
            name="FinancePartnerId"
            value={FinancePartnerData.FinancePartnerId ?? ''}
          />
          <input
            type="text"
            className="form-control"
            name="FinancePartnerName"
            value={FinancePartnerData.FinancePartnerName ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Interest Rate (%)</label>
          <Select
            classNamePrefix="react-select"
            options={interestRateOptions}
            isLoading={interestRateLoading}
            isClearable
            placeholder="Select interest rate"
            value={selectedInterestRate}
            onChange={handleInterestRateChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Minimum Down Payment</label>
          <input
            type="number"
            className="form-control"
            name="MinimumDownPayment"
            step="0.01"
            value={FinancePartnerData.MinimumDownPayment ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Person 1</label>
          <input
            type="text"
            className="form-control"
            name="ContactPerson1"
            value={FinancePartnerData.ContactPerson1 ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Phone 1</label>
          <input
            type="text"
            className="form-control"
            name="ContactPhone1"
            value={FinancePartnerData.ContactPhone1 ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Person 2</label>
          <input
            type="text"
            className="form-control"
            name="ContactPerson2"
            value={FinancePartnerData.ContactPerson2 ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-6 mb-3">
          <label className="form-label">Contact Phone 2</label>
          <input
            type="text"
            className="form-control"
            name="ContactPhone2"
            value={FinancePartnerData.ContactPhone2 ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-12 mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            value={FinancePartnerData.EmailId ?? ''}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )
}

export default EditFinancePartner
